import { useFetch } from "@/hooks/useFetch";
import { PageHeader, Panel, Loading, Tag } from "@/components/common";
import { Brain, Warning, UsersThree, MapPin, Lightning, BookmarkSimple } from "@phosphor-icons/react";

const ICONS = { Character: UsersThree, Event: Lightning, Location: MapPin, Rule: BookmarkSimple };

export default function Canon() {
  const { data: canon, loading } = useFetch("/canon");
  if (loading || !canon) return <Loading />;

  return (
    <div>
      <PageHeader icon={Brain} title="Story Canon · Universe Memory"
        subtitle="Structured memory of this studio's universe. New scripts are checked against canon — contradictions raise a continuity warning." />

      <div className="mb-6 flex items-start gap-3 rounded-xl border border-[#FFB800]/30 bg-[#FFB800]/8 px-4 py-3">
        <Warning size={20} weight="fill" className="text-[#FFB800] mt-0.5" />
        <div>
          <div className="text-sm font-semibold text-white">Continuity check active</div>
          <p className="text-sm text-zinc-400">If a new script contradicts an established fact, Studio AI flags it (e.g. "this character was already introduced in Episode 8"). The owner can always override a warning.</p>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        {canon.map((c) => {
          const Icon = ICONS[c.type] || BookmarkSimple;
          return (
            <Panel key={c.id} hover data-testid={`canon-${c.id}`} className="flex items-start gap-4">
              <div className="h-10 w-10 rounded-xl bg-white/5 flex items-center justify-center shrink-0">
                <Icon size={20} weight="duotone" className="text-[#00E5FF]" />
              </div>
              <div>
                <div className="flex items-center gap-2 mb-1"><Tag>{c.type}</Tag><span className="text-[11px] text-zinc-500">{c.episode}</span></div>
                <p className="text-sm text-white">{c.fact}</p>
              </div>
            </Panel>
          );
        })}
      </div>
    </div>
  );
}
